import { Button, Field, Select } from "@deligoo/ui"
import { FormEvent, useEffect, useState } from "react"

import { useAppDispatch, useAppSelector } from "@/App"
import { Card } from "@/components/Card"
import { selectClients } from "@/store/clients"
import { getAllPayments, selectPaymentsUpdateTimestamp } from "@/store/payments"
import { selectCurrentTeamId } from "@/store/teams"

import { getPaymentsDataRange } from ".."
import cls from "../PaymentsView.module.scss"

const DEFAULT_SEARCH_VALUES = {
  "query[order_uid_eq]": "",
  "query[transaction_code_matches]": "",
  "query[order_client_id_eq]": "",
  "query[provider_eq]": "",
}

export const PaymentsSearch = ({ paymentsDate }: { paymentsDate: string }) => {
  const teamId = useAppSelector(selectCurrentTeamId)
  const updateTimestamp = useAppSelector(selectPaymentsUpdateTimestamp)

  const clients = useAppSelector(selectClients)

  const [searchValues, setSearchValues] = useState(DEFAULT_SEARCH_VALUES)

  const dispatch = useAppDispatch()

  function setInputValue(e: FormEvent<HTMLInputElement | HTMLSelectElement>) {
    const { name, value } = e.currentTarget

    setSearchValues({ ...searchValues, [name]: value })
  }

  function submitPaymentsSearch(e: FormEvent<HTMLFormElement>) {
    e.preventDefault()

    if (!teamId) return

    dispatch(
      getAllPayments({
        teamId,
        paymentsParams: {
          ...getPaymentsDataRange(paymentsDate),
          ...searchValues,
        },
      })
    )
  }

  useEffect(() => {
    setSearchValues(DEFAULT_SEARCH_VALUES)
  }, [teamId, updateTimestamp])

  return (
    <Card box className="mt-6">
      <Card.Header>Wyszukiwarka</Card.Header>

      <Card.Section>
        <form className={cls.searchForm} onSubmit={submitPaymentsSearch}>
          <Field
            name="query[order_uid_eq]"
            label="Numer zamówienia"
            inputProps={{
              onChange: setInputValue,
              value: searchValues["query[order_uid_eq]"],
              size: "medium",
            }}
          />

          <Field
            name="query[transaction_code_matches]"
            label="Kod transakcji"
            inputProps={{
              onChange: setInputValue,
              value: searchValues["query[transaction_code_matches]"],
              size: "medium",
            }}
          />

          <Field name="client" label="Lokalizacja">
            <Select
              id="client"
              name="query[order_client_id_eq]"
              value={searchValues["query[order_client_id_eq]"]}
              onChange={setInputValue}
            >
              <option value="">Wszystkie</option>

              {clients.map((client) => (
                <option value={client.id} key={client.uuid}>
                  {client.name}
                </option>
              ))}
            </Select>
          </Field>

          <Field name="provider" label="Terminal">
            <Select
              id="provider"
              name="query[provider_eq]"
              value={searchValues["query[provider_eq]"]}
              onChange={setInputValue}
            >
              <option defaultChecked value="">
                Wszystkie
              </option>
              <option value="sumup">Sumup</option>
              <option value="apipay">apipay</option>
            </Select>
          </Field>

          <Button color="primary" type="submit">
            Wyszukaj
          </Button>
        </form>
      </Card.Section>
    </Card>
  )
}
